module.exports = __webpack_public_path__ + "static/media/profile.47ff95e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/profile.png
// module id = 674
// module chunks = 1